import { render } from "./land-purchase-count.vue?vue&type=template&id=1e8ef520&scoped=true"
import script from "./land-purchase-count.vue?vue&type=script&lang=js"
export * from "./land-purchase-count.vue?vue&type=script&lang=js"

import "./land-purchase-count.vue?vue&type=style&index=0&id=1e8ef520&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8ef520"]])

export default __exports__